import { RedoOutlined, RetweetOutlined, CopyOutlined } from "@ant-design/icons";
import { Button, Card, Form, Modal, Row, Select, Table, Input } from "antd";
import OrderStatus, { StatusSwitcher } from "constants/OrderStatus";
import React, { useEffect, useState } from "react";
import { MessagesService } from "services/Messages";
import dayjs from "dayjs";
import initial_filter from "constants/InitialFilter";
import { ApplicationApi } from "api/ApplicationApi";
import Loading from "components/shared-components/Loading";
import { formatCurrency } from "utils/formatCurrency";
import Search from "antd/lib/input/Search";

export default function Application() {
  // Table columns
  const columns = [
    {
      title: "Номер заказа",
      width: 60,
      dataIndex: "id",
      key: "id",
      render: (number) => (
        <Button
          type="link"
          onClick={() => {
            navigator.clipboard.writeText(number);
            MessagesService.success("Скопировано");
          }}
        >
          {number}
          <CopyOutlined />
        </Button>
      ),
    },
    {
      title: "Почтовый номер",
      width: 100,
      dataIndex: "box_number",
      key: "box_number",
      render: (number) =>
        number && (
          <Button
            type="link"
            onClick={() => {
              navigator.clipboard.writeText(number);
              MessagesService.success("Скопировано");
            }}
          >
            {number}
            <CopyOutlined />
          </Button>
        ),
    },
    {
      title: "Телеграм",
      width: 200,
      dataIndex: "user",
      key: "user",
      render: (user) => (
        <a href={`https://t.me/${user.username}`} target="_blank">
          {user.first_name} {user.last_name}
        </a>
      ),
    },
    {
      title: "Итого",
      width: 100,
      dataIndex: "total",
      key: "total",
      render: (total) => formatCurrency(total),
    },
    {
      title: "Статус",
      width: 100,
      dataIndex: "status",
      key: "status",
      render: (record) => StatusSwitcher(record),
    },
    {
      title: "Дата создания",
      width: 100,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => {
        return dayjs(record).format("DD.MM.YYYY, HH:MM");
      },
    },
    {
      title: "Действие",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => {
        return (
          <div>
            <Button
              ghost
              size="middle"
              type="primary"
              onClick={() => {
                setOpen(true);
                form.setFieldsValue(record);
              }}
            >
              <RetweetOutlined />
            </Button>
          </div>
        );
      },
    },
  ];
  // States
  const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(initial_filter);
  const [form] = Form.useForm();
  const [status, setStatus] = useState();
  // Get application types
  useEffect(() => {
    fetch(filter);
  }, []);

  function fetch(filter) {
    setLoading(true);
    ApplicationApi.get(filter)
      .then((res) => {
        setData(res);
        setFilter({
          ...filter,
          total: res.total,
          page: res.page,
        });
        setLoading(false);
      })
      .catch((err) => {
        MessagesService.error(err.message);
        setLoading(false);
      });
  }

  const changeStatus = (values) => {
    ApplicationApi.edit(form.getFieldValue().id, values)
      .then((res) => {
        setData({
          ...data,
          items: data.items.map((item) => {
            return item.id === form.getFieldValue().id ? res.item : item;
          }),
        });
        MessagesService.success("Статус изменен");
        setOpen(false);
        form.setFieldValue();
      })
      .catch(() => {
        MessagesService.error("Ошибка");
      });
  };

  // Render
  return loading ? (
    <Loading />
  ) : (
    <>
      <Card>
        <h4 className="font-semibold text-base mb-3">Заказы</h4>
        <Row className="justify-between items-center">
          <Search
            type="text"
            className="w-3/5"
            size="large"
            enterButton="Поиск"
            defaultValue={filter.keyword}
            placeholder="Поиск по имени пользователя..."
            onSearch={(value) => {
              setFilter({ ...filter, keyword: value });
              fetch({ ...filter, keyword: value });
            }}
          />
          <Button
            icon={<RedoOutlined />}
            size="large"
            onClick={() => fetch(filter)}
          >
            Обновить
          </Button>
        </Row>
      </Card>
      <Card>
        <Table
          columns={columns}
          loading={loading}
          rowKey={(record) => record.id}
          expandable={{
            expandedRowRender: (record) => {
              const columns = [
                {
                  title: "Название продукта",
                  dataIndex: "name",
                  key: "name",
                },
                {
                  title: "Название категории",
                  dataIndex: "category",
                  key: "category",
                  render: (record, _) => {
                    return _?.product?.category?.name;
                  },
                },
                {
                  title: "Размер",
                  dataIndex: "size",
                  key: "size",
                },
                {
                  title: "Цвет",
                  dataIndex: "color",
                  key: "color",
                  render: (color) => {
                    return (
                      <div
                        className="w-10 h-6 rounded-md"
                        style={{ backgroundColor: color }}
                      />
                    );
                  },
                },
                {
                  title: "Цена",
                  dataIndex: "price",
                  key: "price",
                  render: (record) => {
                    return formatCurrency(record);
                  },
                },
                {
                  title: "Количество",
                  dataIndex: "count",
                  key: "count",
                },
              ];
              return (
                <>
                  <Table
                    columns={columns}
                    pagination={false}
                    dataSource={record?.order_items}
                  />
                  <h5 className="d-flex justify-content-end mt-2">
                    <b>Итого:&nbsp;</b>
                    {formatCurrency(record?.total)}
                  </h5>
                </>
              );
            },
          }}
          onChange={(p, _, sort) => {
            const f = {
              ...filter,
              page: p.current,
              limit: p.pageSize,
            };
            setFilter(f);
            fetch(f);
          }}
          pagination={{
            current: filter.page,
            total: data?.total,
            pageSize: filter.limit,
            showSizeChanger: true,
            pageSizeOptions: ["15", "25", "50"],
          }}
          dataSource={data?.items}
        />
      </Card>
      <Modal
        title="Изменить статус заявки"
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        width={400}
      >
        <Form
          layout="vertical"
          form={form}
          name={"Change status"}
          onFinish={changeStatus}
        >
          <Form.Item label="Статус" name="status">
            <Select
              placeholder="Статус"
              size="large"
              onChange={(value) => {
                setStatus(value);
                form.setFieldValue("box_number", null);
              }}
              options={Object.entries(OrderStatus).map(([value, label]) => {
                return { value, label };
              })}
            />
          </Form.Item>
          {status === "sent" && (
            <Form.Item label="Почтовый номер" name="box_number">
              <Input type="text" placeholder="Почтовый номер" />
            </Form.Item>
          )}
          <Form.Item className="flex justify-end mb-0">
            <Button type="primary" size="large" htmlType="submit">
              Изменить
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
